import moment from 'moment';
import { startCase, parseInt } from 'lodash';
import { ControlPanelSteps } from '@upstart/harmony/lib/flow-utils';

// Simplify complex properties
const CUSTOM_NORMALIZER = {
  hours: (value) => {
    if (!value || typeof value !== 'string') return '';
    const [startDay, endDay] = value.split(' ')[0].split('-');
    const [startHour, endHour] = value.split(' ')[1].split('-');
    return `${moment()
      .isoWeekday(parseInt(startDay))
      .format('dddd')} - ${moment()
      .isoWeekday(parseInt(endDay))
      .format('dddd')} ${moment()
      .hour(parseInt(startHour))
      .format('ha')} - ${moment().hour(parseInt(endHour)).format('ha')}`;
  },
  controlPanelFlow: (flow) => {
    if (!flow) return null;
    const stepOrder = flow.map((step) => step.name).join(' → ');

    const getStepName = (id) =>
      Object.values(ControlPanelSteps).find((s) => s.id === id).name;

    return flow.reduce(
      (acc, step) => {
        const depends = (step.depends || []).map(getStepName).join(', ');
        acc[step.name] = 'ON';
        acc[`${step.name} depends on`] = depends;
        return acc;
      },
      { stepOrder },
    );
  },
  FormTemplates: (formTemplates = []) =>
    formTemplates.reduce(
      (acc, template) => ({ ...acc, [template.name]: 'ON' }),
      {},
    ),
  Feeds: (feeds = []) =>
    feeds.reduce((acc, feed) => ({ ...acc, [feed.name]: 'ON' }), {}),
};

/**
 * Normalize value before generating a diff.
 */
const normalizeValue = (key, value) => {
  const customNormalizer = CUSTOM_NORMALIZER[key];

  // Use custom normalizer for the property if it exists.
  if (customNormalizer) {
    return customNormalizer(value);
  }

  switch (typeof value) {
    // Normalize boolean to readable value
    case 'boolean':
      return value ? 'ON' : 'OFF';
    default:
      break;
  }

  return value;
};

/**
 * Transform path to a readable string.
 */
export const normalizePath = (path) => {
  const readablePath = path
    .join('.')
    .split('.')
    .map(startCase)
    .reduce((acc, val) => {
      if (/^\d+$/.test(val)) {
        const last = acc.pop();
        const num = parseInt(val, 10) + 1;
        acc.push(`${last} #${num}`);
      } else {
        acc.push(val);
      }
      return acc;
    }, []);
  return readablePath;
};

export const normalizeDiffItem = (path, key, lhs, rhs) => [
  normalizeValue(key, lhs),
  normalizeValue(key, rhs),
];
